import { User } from 'models';
import React from 'react';

export interface ViewAsContext {
  user: User;
  isPreview: boolean;
}

export const ViewAsContext = React.createContext<ViewAsContext | undefined>(undefined);
